var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Muted"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Muted",
    clipPath: "url(#clip-Muted)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    transform: "translate(-2862 -1941)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_629",
    "data-name": "Ellipse 629",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(2862 1941)",
    className: "icon-background"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-microphone-slash",
    "data-name": "Icon awesome-microphone-slash",
    d: "M32.871,23.758l-8.184-6.325a8.912,8.912,0,0,0,1.036-4.156V10.787a.83.83,0,0,0-.83-.83h-.83a.83.83,0,0,0-.83.83v2.489a6.45,6.45,0,0,1-.556,2.6L21.3,14.816a4.882,4.882,0,0,0,.274-1.539v-8.3a4.979,4.979,0,1,0-9.957,0V7.331L2.358.175A.83.83,0,0,0,1.193.321L.175,1.631A.83.83,0,0,0,.321,2.8L30.834,26.378A.83.83,0,0,0,32,26.233l1.019-1.311A.83.83,0,0,0,32.871,23.758Zm-12.126.306h-2.9V22.312a9.03,9.03,0,0,0,1.746-.431l-2.6-2.009a6.688,6.688,0,0,1-1.055.01A6.716,6.716,0,0,1,10.166,14.6l-2.7-2.086v.355a9.413,9.413,0,0,0,7.883,9.423v1.771h-2.9a.83.83,0,0,0-.83.83v.83a.83.83,0,0,0,.83.83h8.3a.83.83,0,0,0,.83-.83v-.83A.83.83,0,0,0,20.745,24.064Z",
    transform: "translate(2869.711 1952.234)",
    className: "icon-foreground"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.5b5b768e01f21293f621cb90d735af75.svg";
export { ForwardRef as ReactComponent };